import Vue from 'vue'
import Vuex from 'vuex'

import loader from '../utils/loader'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: loader.getByFileName(require.context('./modules', true, /\.(js)$/))
})



// WEBPACK FOOTER //
// ./src/store/index.js